import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { DataTableModule } from "@bfx/primeng/datatable";
import { TranslateModule } from "@ngx-translate/core";

import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BaseComponentsModule } from "../../shared/base-components/base-components.module";
import { ButtonModule } from "@bfx/primeng/button";
import { BfxExecutionMonitorComponent } from "app/bfx-execution-monitor/bfx-execution-monitor.component";
import { BfxExecutionMonitorContextMenuService } from "app/bfx-execution-monitor/services/bfx-execution-monitor-context-menu.service";
import { BfxExecutionMonitorMenuService } from "app/bfx-execution-monitor/services/bfx-execution-monitor-menu.service";
import { BfxExecutionMonitorService } from "app/bfx-execution-monitor/services/bfx-execution-monitor.service";
import { BfxBlotterOrdersModule } from "app/bfx-blotter-orders/bfx-blotter-orders.module";
import { BfxBlotterOrdersActionSubjectModule } from "app/bfx-blotter-orders/bfx-blotter-orders-action-subject.module";

@NgModule({
  imports: [
    CommonModule,
    DataTableModule,
    BfxSharedModule,
    TranslateModule,
    AutoCompleteModule,
    BfxElementsLibraryModule,
    NativeDesktopModule,
    ButtonModule,
    BfxBlotterOrdersModule,
    BfxBlotterOrdersActionSubjectModule,
    BaseComponentsModule,
  ],
  declarations: [BfxExecutionMonitorComponent],
  providers: [
    BfxExecutionMonitorService,
    BfxExecutionMonitorMenuService,
    BfxExecutionMonitorContextMenuService,
  ],
  exports: [BfxExecutionMonitorComponent],
  bootstrap: [],
})
export class BfxExecutionMonitorModule {}
